export const monitoring = {
  captureError: (error: Error, context?: any) => {
    console.error('Error captured:', error, context);
    // TODO: Integrar con Sentry
  },
  captureFrontendError: (error: Error, context?: any) => {
    console.error('Frontend Error captured:', error, context);
    // TODO: Integrar con Sentry
  },
  captureMessage: (message: string, level?: string, context?: any) => {
    console.log(`[${level || 'info'}] ${message}`, context);
  },
  captureETLError: (error: Error, context?: any) => {
    console.error('ETL Error:', error, context);
  },
  captureValidationError: (entity: string, row: number, field: string, value: any, message: string) => {
    console.warn(`Validation Error [${entity}][Row ${row}][Field ${field}]: ${message}`, value);
  },
  captureImportError: (entity: string, totalRows: number, failedRows: number, error: Error) => {
    console.error(`Import Error [${entity}]: ${failedRows}/${totalRows} failed`, error);
  },
  logBusinessEvent: (event: string, data?: any) => {
    console.log(`Business Event: ${event}`, data);
  },
  addBreadcrumb: (message: string, data?: any) => {
    console.log(`Breadcrumb: ${message}`, data);
  },
  log: (data: any) => {
    console.log('Log:', data);
  }
};